exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth[data-v-09ae86e8] {\n    -webkit-user-select: none;\n       -moz-user-select: none;\n            user-select: none;\n}\n", ""]);

// exports
